import type React from 'react';

const TypingIndicator: React.FC<{ show: boolean }> = ({ show }) => {
  return (
    <>
      {show && (
        <div className='typing-indicator-container'>
          <div className='typing-indicator-row'>
            <div className='typing-indicator-dot' />
            <div className='typing-indicator-dot' />
            <div className='typing-indicator-dot' />
          </div>
        </div>
      )}
    </>
  );
};

export default TypingIndicator;
